
// API firebase proxy
module.exports = "https://us-central1-shiftpollmbti.cloudfunctions.net/api"